import React from 'react';
import {
  CircularProgress,
  Typography,
  Paper,
  useMediaQuery,
  useTheme
} from '@mui/material';
import {useTranslation} from 'react-i18next';

interface LayoutLoadingProps {
  message?: string;
}
const LayoutLoading: React.FC<LayoutLoadingProps> = ({message}) => {
  {
    const {t} = useTranslation();
    const theme = useTheme();
    const isXsScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const variant = message ? (isXsScreen ? 'h6' : 'h5') : 'h4';

    return (
      <Paper
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh'
        }}
      >
        <Typography
          variant={variant}
          align="center"
          gutterBottom
          sx={{
            display: {xs: message ? 'flex' : 'none', sm: 'flex'}
          }}
        >
          {message ? t(message) : t('lbl_loading')}
        </Typography>
        <CircularProgress
          size={60}
          sx={{
            margin: 2,
            marginRight: 4
          }}
        />
      </Paper>
    );
  }
};

export default LayoutLoading;
